import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'ui-components/default-props/noop';
import { ProviderTypes } from './constants';
import { CuiProviderSettings } from './provider-settings';
import { useApiCodeFromAccountId } from './hooks/use-api-code-from-account-id';

export const FulfillmentProviderSettings = ({
  sellerFulfillmentProviderId,
  onSave = noop,
  onError = noop,
  onCancel = noop,
  onUpdateSellerData = noop,
}) => {
  const providerApiCode = useApiCodeFromAccountId(sellerFulfillmentProviderId, ProviderTypes.fulfillment);

  if (!providerApiCode) {
    return null;
  }

  return (
    <CuiProviderSettings
      accountId={sellerFulfillmentProviderId}
      onCancel={onCancel}
      onError={onError}
      onSave={onSave}
      onUpdateSellerData={onUpdateSellerData}
      providerApiCode={providerApiCode}
      providerType={ProviderTypes.fulfillment}
    />
  );
};

FulfillmentProviderSettings.propTypes = {
  sellerFulfillmentProviderId: PropTypes.string.isRequired,
  onSave: PropTypes.func,
  onUpdateSellerData: PropTypes.func,
  onError: PropTypes.func,
  onCancel: PropTypes.func,
};
